import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { Routes } from "../../routes";
import Preloader from "../Preloader";
import ToastContainer from "../ToastContainer";

const RouteWithFullView = ({ component: Component, ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoaded(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    const localStorageIsSettingsVisible = () => {
        return localStorage.getItem('settingsVisible') === 'false' ? false : true
    }

    const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

    if (rest.isAuthenticated) {
        return (
            <Route {...rest} render={props => (
                <>
                    {/* <Preloader show={loaded ? false : true} /> */}
                    <main>
                        <ToastContainer />
                        <Component {...props} />
                    </main>
                </>
            )}
            />
        );
    } else {
        return (
            <Redirect to={Routes.SignIn.path} />
        )
    }
};

const mapStateToProps = state => {
    return { isAuthenticated: state.auth.isAuthenticated };
};

export default connect(mapStateToProps)(RouteWithFullView);